import { EntDirectoryInfoName } from '../directoryInfoName'
import { EntTerritorialsUnits } from '../handBooks/territorialsUnits'
import { EntKurultaiTask } from './kurultaiItem'

export interface IRegionBlock {
	region: {
		id: number
		// ...другие поля...
		nameRu: string
	}
	areas?: IAreaBlock[]
	totalAssignments?: number
	completionPercentage?: number
}

export interface IAreaBlock {
	area: {
		id: number
		// ...другие поля...
		nameRu: string
	}
	categoryAssignments?: ICategoryAssignment[]
	totalAssignments?: number
	completionPercentage?: number
}

export interface ICategoryAssignment {
	categoryNameRu: string
	categoryNameKy: string
	assignments?: Assignment[]
}

// И теперь в EntKurultaiRegister:
export class Assignment {
	key: string | undefined = undefined
	id: number | null = null
	questionCategoryId: number | null = null
	questionCategory?: EntDirectoryInfoName | null = null
	question: string | null = null
	questionDescription: string | null = null
	sourceOfFunding: string | null = null
	completionPercentage?: number | null = null
	kurultaiRegisterId?: number | null = null
	tasksList: EntKurultaiTask[] | null = null
	delegateName?: string | null = null
	territorialUnitId?: number | null = null
	longitude?: number | null = null
	latitude?: number | null = null
}

export class EntKurultaiRegister {
	id: number | null = null
	assemblyNumber: string | null = null
	assemblyDate: string | null = null
	delegateName: string | null = null
	territorialUnitId: number | null = null
	territorialUnit: EntTerritorialsUnits | null = null
	longitude: number | null = null
	latitude: number | null = null
	regions?: IRegionBlock[] | null = null
	regionId: number | null = null
	areaId: number | null = null
	areas?: IAreaBlock[] | null = null
	assignmentsList: Assignment[] | null = null
}
